import { Box, Button, Chip, Tooltip } from '@material-ui/core';
import { AttachFile } from '@material-ui/icons';
import { defaultAcceptableFileTypes } from 'components/uploadDocs';
import React, { useRef } from 'react';

interface CompactUploadProps {
  arquivos: File[];
  onChange: (novosArquivos: File[]) => void;
  onRemove: (index: number) => void;
  disabled?: boolean;
  maxFileNameLength?: number;
  botaoAlinhamento?: 'esquerda' | 'direita';
}

const CompactUpload: React.FC<CompactUploadProps> = ({
  arquivos,
  onChange,
  onRemove,
  disabled = false,
  maxFileNameLength = 20,
  botaoAlinhamento = 'esquerda',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const acceptedFileTypes = defaultAcceptableFileTypes;

  const handleClick = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const novosArquivos = Array.from(event.target.files).filter((file) =>
      acceptedFileTypes.some((type) => file.type === type)
    );

    if (novosArquivos.length > 0) {
      onChange(novosArquivos);
    }

    if (inputRef.current) inputRef.current.value = '';
  };

  const truncarNome = (nome: string) => {
    if (nome.length <= maxFileNameLength) return nome;
    const extensao = nome.lastIndexOf('.') > 0 ? nome.slice(nome.lastIndexOf('.')) : '';
    const nomeBase = nome.slice(0, maxFileNameLength - extensao.length - 3);
    return `${nomeBase}...${extensao}`;
  };

  const botaoAnexar = (
    <Button
      size="small"
      variant="text"
      startIcon={<AttachFile fontSize="small" />}
      onClick={handleClick}
      disabled={disabled}
      style={{ whiteSpace: 'nowrap', textTransform: 'none' }}
    >
      {'Anexar arquivo'}
    </Button>
  );

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      style={{
        gap: 8,
        border: '1px solid #E0E0E0',
        borderRadius: 4,
        padding: '4px 8px',
      }}
    >
      {botaoAlinhamento === 'esquerda' && botaoAnexar}

      <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 8, flex: 1 }}>
        {arquivos.map((arquivo, index) => (
          <Tooltip key={index} title={arquivo.name}>
            <Chip size="small" label={truncarNome(arquivo.name)} onDelete={() => onRemove(index)} variant="outlined" />
          </Tooltip>
        ))}
      </Box>

      <input
        ref={inputRef}
        type="file"
        accept={acceptedFileTypes.join(',')}
        multiple
        style={{ display: 'none' }}
        onChange={handleInputChange}
      />

      {botaoAlinhamento === 'direita' && botaoAnexar}
    </Box>
  );
};

export default CompactUpload;
